import { render, staticRenderFns } from "./Add1.vue?vue&type=template&id=28274e59&"
import script from "./Add1.vue?vue&type=script&lang=js&"
export * from "./Add1.vue?vue&type=script&lang=js&"
import style0 from "./Add1.vue?vue&type=style&index=0&id=28274e59&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports